import { useEffect, useState } from 'react';

/** Google's display-ad viewability threshold. */
export const VIEWABLE_MS = 1000;

/**
 * True once the page has stayed visible for `durationMs` without interruption while
 * `enabled`. Hiding the page restarts the wait; once reached, it stays true.
 */
export function usePageVisibleFor(durationMs: number, enabled: boolean): boolean {
    const [reached, setReached] = useState(false);

    useEffect(() => {
        if (!enabled || reached) return;

        let timer: ReturnType<typeof setTimeout> | undefined;
        const restart = () => {
            clearTimeout(timer);
            if (document.visibilityState === 'visible') {
                timer = setTimeout(() => setReached(true), durationMs);
            }
        };

        restart();
        document.addEventListener('visibilitychange', restart);
        return () => {
            clearTimeout(timer);
            document.removeEventListener('visibilitychange', restart);
        };
    }, [durationMs, enabled, reached]);

    return reached;
}
